<template>
  <div class="container_box">
    <!--Tab区域-->
    <Tabs v-if="systemConfigData.length >0" v-model="systemConfigValue" :animated="false" class="tabs_styles" @on-click="tabChange">
      <TabPane v-for="item in systemConfigData" :label="(h)=>labelRender(h, item)" :name="item.value"></TabPane>
    </Tabs>
    <!--列表区域-->
    <div class="table_box mt15">
      <Table
        border
        highlight-row
        max-height="600"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--LOGO配置弹窗-->
    <logoConfigModal @updateConfigData="getSystemConfigList" ref="logoConfig"></logoConfigModal>
    <!--语种配置弹窗-->
    <languageConfigModal
      :enumData="enumData"
      @updateConfigData="getSystemConfigList"
      ref="languageConfig">
    </languageConfigModal>
    <!--第三方平台配置弹窗-->
    <suppliePlatformConfigModal
      :enumData="enumData"
      @updateConfigData="getSystemConfigList"
      ref="suppliePlatformConfig">
    </suppliePlatformConfigModal>
    <!--订单自动取消配置弹窗-->
    <autoCancelOrderConfigModal
      @updateConfigData="getSystemConfigList"
      ref="autoCancelOrderConfig">
    </autoCancelOrderConfigModal>
    <!--跨境电商平台配置弹窗-->
    <distributorPlatformConfigModal
      :enumData="enumData"
      @updateConfigData="getSystemConfigList"
      ref="distributorPlatformConfig">
    </distributorPlatformConfigModal>
    <!--在线支付渠道配置弹窗-->
    <onlineBalanceRechargeConfigModal
      :enumData="enumData"
      @updateConfigData="getSystemConfigList"
      ref="onlineBalanceRechargeConfig">
    </onlineBalanceRechargeConfigModal>
    <!--商品详情页按钮布局配置弹窗-->
    <buttonLayoutConfigurationModal
      @updateConfigData="getSystemConfigList"
      ref="buttonLayoutConfiguration">
    </buttonLayoutConfigurationModal>
    <!--商城注册分销商默认业务类型配置弹窗-->
    <mallRegisterBusinessTypeConfigModal
      @updateConfigData="getSystemConfigList"
      :businessTypeList="businessTypeList"
      ref="mallRegisterBusinessTypeConfig">
    </mallRegisterBusinessTypeConfigModal>
    <!--商城游客价格展示配置弹窗-->
    <touristPriceConfigModal
      @updateConfigData="getSystemConfigList"
      :touristPricesTypeList="touristPricesTypeList"
      :showProductWholesaleModel="showProductWholesaleModel"
      ref="touristPriceConfig">
    </touristPriceConfigModal>
    <!--平台账单周期配置弹窗-->
    <platformSelfOperatedProductModel
      @updateConfigData="getSystemConfigList"
      ref="platformSelfOperatedProductConfig">
    </platformSelfOperatedProductModel>
    <!--商城右侧悬浮信息展示配置弹窗-->
    <mallRightFloatingInfoConfigModal
      @updateConfigData="getSystemConfigList"
      ref="mallRightFloatingInfoConfig">
    </mallRightFloatingInfoConfigModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import {SYSTEMCONFIGDATA} from "@/utils/enum";
import logoConfigModal from "@/views/yms/components/basicSettings/logoConfigModal.vue";
import languageConfigModal from "@/views/yms/components/basicSettings/languageConfigModal.vue";
import suppliePlatformConfigModal from "@/views/yms/components/basicSettings/suppliePlatformConfigModal.vue";
import autoCancelOrderConfigModal from "@/views/yms/components/basicSettings/autoCancelOrderConfigModal.vue";
import distributorPlatformConfigModal from "@/views/yms/components/basicSettings/distributorPlatformConfigModal.vue";
import onlineBalanceRechargeConfigModal from "@/views/yms/components/basicSettings/onlineBalanceRechargeConfigModal.vue";
import buttonLayoutConfigurationModal from "@/views/yms/components/basicSettings/buttonLayoutConfigurationModal.vue";
import mallRegisterBusinessTypeConfigModal from "@/views/yms/components/basicSettings/mallRegisterBusinessTypeConfigModal.vue";
import touristPriceConfigModal from "@/views/yms/components/basicSettings/touristPriceConfigModal.vue";
import platformSelfOperatedProductModel from "@/views/yms/components/basicSettings/platformSelfOperatedProductModel.vue";
import mallRightFloatingInfoConfigModal from "@/views/yms/components/basicSettings/mallRightFloatingInfoConfigModal.vue";
import {getCommonParamKeysData, saveErpCommonSettingParam, commonLocalStorage, isJSON, getDataSetBatchList, getEnumList} from "@/utils/common";

export default {
  name: 'systemConfigList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      systemConfigValue: null,
      labelRender: (h, params) => {
        return h('div', {
          class: 'flex align-items-center'
        }, [
          h('i', {
            class: 'iconfont',
            style: {color: '', marginRight: '5px', position: 'relative', top: '-1px'},
            domProps: {innerHTML: '&#xe79d;'}
          }),
          h('span', params.title)
        ])
      },
      statusParamsKeyList: [
        'enableShowProductTagInMall', // 商品标签展示
        'enableProductSaleCountrySet', // 商品可售卖国
        'offlinePayment', // 线下支付
        'platformOrderShippingWarehouseConfig', // 平台订单发货仓匹配配置
      ],
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002459'),
          key: 'name',
          minWidth: 150,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002460'),
          key: 'description',
          minWidth: 700,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002461'),
          key: 'status',
          minWidth: 300,
          align: 'left',
          render: (h, params) => {
            return v.processingStatusText(h, params.row)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 150,
          align: 'left',
          render: (h, params) => {
            let paramKey = params.row.paramKey;
            let paramValue = params.row.paramValue;
            let statusTalg = v.statusParamsKeyList.includes(paramKey);
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002462'),
                    show: !statusTalg && v.checkConfigPermission(),
                    clickFn: () => {
                      v.configurationItemBtn(params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: statusTalg && Number(paramValue) === 1 && v.checkConfigPermission(),
                    clickFn: () => {
                      v.enableDisableBtn('disable', params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: statusTalg && Number(paramValue) === 0 && v.checkConfigPermission(),
                    clickFn: () => {
                      v.enableDisableBtn('enable', params.row);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      touristPricesTypeList: [
        {value: 'hidePrice', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002463')},
        {value: 'showRetailPrice', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002464')},
        {value: 'showWholesalePrice', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002465')}
      ],
      systemConfigData: [],
      enumData: {},
      enumList: []
    }
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 业务类型
    businessTypeList() {
      const ENUM_KEY = 'YmsDistributorMerchantDetailDistributorTypeCoreEnum';
      return getEnumList(this.enumList, ENUM_KEY)
    },
    // 批发模式
    showProductWholesaleModel() {
      const obj = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(obj?.productWholesaleModelSaas) === 1;
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化入口
    async initData() {
      try {
        // 配置项的枚举数据集
        let enumMap = {};
        let enumKeyList = [
          'LanguageEnum',
          'DistributorPlatformEnum',
          'PaymentMethodEnum',
          'SupplierPlatformEnum',
          'YmsDistributorMerchantDetailDistributorTypeCoreEnum'
        ];
        this.enumList = await getDataSetBatchList(enumKeyList);
        this.enumList.forEach(item => {
          enumMap[`${item.enumKey}_${item.value}`] = item.name;
        });
        this.enumData = enumMap;
        // 是否开启批发模式
        await this.initWholesaleModel();
        // 初始化系统配置Tab
        const systemList = await this.handleSystemConfigData();
        if (!systemList.length) return;
        this.systemConfigData = systemList;
        this.systemConfigValue = systemList[0].value;
        // 获取配置列表
        this.getSystemConfigList();
      } catch (e) {
        console.error('initData error:', e);
      }
    },
    // 批发模式
    async initWholesaleModel() {
      if (this.showProductWholesaleModel) {
        this.touristPricesTypeList.forEach(item => {
          if (item.value === 'showRetailPrice') {
            item.name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002466');
          }
        });
      }
    },
    // 处理数据
    handleSystemConfigData() {
      return new Promise((resolve) => {
        const configMap = [
          {
            value: 'yms',
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002467'),
            permissions: ['ymsConfig_query', 'ymsConfig_update']
          },
          {
            value: 'distributor',
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002468'),
            permissions: ['distributorConfig_query', 'distributorConfig_update']
          },
          {
            value: 'supplier',
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002469'),
            permissions: ['supplierConfig_query', 'supplierConfig_update']
          }
        ];
        let list = configMap.filter(item => item.permissions.some(p => this.getPermission(p))).map(({value, title}) => ({value, title}));
        resolve(list);
      });
    },
    // 获取配置项列表数据
    getSystemConfigList() {
      this.tableData = [];
      let rawData = SYSTEMCONFIGDATA[this.systemConfigValue];
      let paramKeys = rawData.map(item => item.paramKey);
      getCommonParamKeysData(this.userInfo.merchantId, paramKeys, false, true).then((data) => {
        rawData.forEach(item => {
          let matched = data.find(ele => item.paramKey === ele.paramKey);
          if (matched && matched.paramValue) {
            item.paramValue = isJSON(matched.paramValue) ? JSON.parse(matched.paramValue) : matched.paramValue;
          } else {
            item.paramValue = '';
          }
          this.tableData.push(item);
        });
      });
    },
    // 配置项按钮
    configurationItemBtn(obj) {
      let {paramValue, paramKey} = obj;
      switch (paramKey) {
        // logo配置
        case 'ymsLogoConfig':
        case 'distributorLogoConfig':
        case 'supplierLogoConfig':
          this.$refs['logoConfig'].initLogoConfigData(paramKey, paramValue);
          break;

        // 语种配置
        case 'ymsLanguage':
        case 'distributorLanguage':
        case 'supplierLanguage':
          this.$refs['languageConfig'].initLanguageConfigData(this.systemConfigValue, obj);
          break;

        // 订单自动取消配置
        case 'autoCancelOrder':
          this.$refs['autoCancelOrderConfig'].initAutoCancelOrderData(paramKey, paramValue);
          break;

        // 跨境电商平台配置
        case 'distributorPlatformSet':
          this.$refs['distributorPlatformConfig'].initDistributorPlatformData(paramKey, paramValue);
          break;

        // 在线支付渠道
        case 'onlineBalanceRecharge':
          this.$refs['onlineBalanceRechargeConfig'].initOnlineBalanceRechargeData(paramKey, paramValue);
          break;

        // 商品详情页按钮布局配置
        case 'mallDetailsPageSettings':
          this.$refs['buttonLayoutConfiguration'].initButtonLayoutConfigurationData(paramKey, paramValue);
          break;

        // 第三方平台配置
        case 'suppliePlatformSet':
          this.$refs['suppliePlatformConfig'].initSuppliePlatformConfigData(paramKey, paramValue);
          break;
        // 商城注册分销商默认业务类型配置
        case 'mallRegisterBusinessType':
          this.$refs['mallRegisterBusinessTypeConfig'].initMallRegisterBusinessTypeData(paramKey, paramValue);
          break;
        // 商城游客价格展示配置
        case 'touristPriceConfig':
          this.$refs['touristPriceConfig'].iniTouristPriceConfigData(paramKey, paramValue);
          break;
        // 平台账单周期配置
        case 'platformSettlementPeriodSet':
          this.$refs['platformSelfOperatedProductConfig'].iniPlatformSelfOperatedProductData(paramKey, paramValue);
          break;
        // 商城右侧悬浮信息展示配置
        case 'mallRightFloatingInfoConfig':
          this.$refs['mallRightFloatingInfoConfig'].initMallRightFloatingInfoConfigData(paramKey, paramValue);
          break;
      }
    },
    // tab切换
    tabChange() {
      this.getSystemConfigList();
    },
    // 启用、停用配置项
    enableDisableBtn(type, obj) {
      const v = this;
      let {paramKey} = obj;
      let queryList = [
        {
          businessId: v.userInfo.merchantId,
          paramKey: paramKey,
          paramValue: type === 'disable' ? 0 : 1,
        }
      ];
      const handleData = (text) => {
        saveErpCommonSettingParam(queryList).then(() => {
          v.$Message.success(text);
          setTimeout(() => {
            v.getSystemConfigList();
          }, 500);
        });
      }
      if (type === 'disable') {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002470'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002471'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            handleData(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002472'));
          },
          onCancel() {
          }
        });
      } else {
        handleData(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002473'));
      }
    },
    // 处理功能状态展示
    processingStatusText(h, row) {
      const {paramKey, paramValue} = row;
      const nodes = [];
      // Badge
      const renderBadge = enabled =>
        h('Badge', {
          class: enabled ? 'enableStyle' : 'deactivateStyle',
          props: {
            status: enabled ? 'success' : 'error',
            text: enabled ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')
          }
        });
      // 根据 value 从 enumData 取 name
      const getName = (key, value) => this.enumData?.[`${key}_${value}`] || '';
      const rules = [
        // 简单开关
        {
          keys: this.statusParamsKeyList,
          handler: () => ({
            enabled: Number(paramValue) === 1
          })
        },
        // 有配置即启用
        {
          keys: [
            'ymsLogoConfig',
            'distributorLogoConfig',
            'supplierLogoConfig',
            'mallDetailsPageSettings',
            'platformSettlementPeriodSet'
          ],
          handler: () => ({
            enabled: paramValue && Object.keys(paramValue).length > 0
          })
        },
        // 语种配置
        {
          keys: ['ymsLanguage', 'distributorLanguage', 'supplierLanguage'],
          handler: () => {
            const enabled = Array.isArray(paramValue) && paramValue.length > 0;
            if (!enabled) return {enabled};
            const names = paramValue.map(i => {
              const name = getName('LanguageEnum', i.code);
              return i.defaultLanguage ? `${name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002456')}` : name;
            });
            const text = paramKey === 'ymsLanguage' ? `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002457')}"${names[0]}"）` : `（${names.join('、')}）`;
            return {enabled, text};
          }
        },
        // 多选配置
        {
          keys: [
            'distributorPlatformSet',
            'onlineBalanceRecharge',
            'suppliePlatformSet'
          ],
          handler: () => {
            const enumKeyMap = {
              distributorPlatformSet: 'DistributorPlatformEnum',
              onlineBalanceRecharge: 'PaymentMethodEnum',
              suppliePlatformSet: 'SupplierPlatformEnum'
            };
            const enumKey = enumKeyMap[paramKey];
            const enabled = Array.isArray(paramValue) && paramValue.length > 0;
            const names = enabled ? paramValue.map(i => getName(enumKey, i)).filter(Boolean) : [];
            return {
              enabled,
              text: enabled ? `（${names.join('、')}）` : '',
              overflow: names.length > 3
            };
          }
        },
        // 自动取消订单
        {
          keys: ['autoCancelOrder'],
          handler: () => {
            if (!paramValue) return {enabled: false};
            const enabled = Number(paramValue.autoCancelOrderValue) === 1;
            return {
              enabled,
              text: enabled ? `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002458')}${paramValue.autoCancelOrderTime}min）` : ''
            };
          }
        },
        // 单选配置--回显选中值
        {
          keys: ['touristPriceConfig', 'mallRegisterBusinessType'],
          handler: () => {
            if (!paramValue) return {enabled: false};
            const enabled = paramValue;
            let obj = {};
            this.businessTypeList.forEach(i => {
              obj[i.value] = i.name;
            });
            this.touristPricesTypeList.forEach(i => {
              obj[i.value] = i.name;
            });
            let text = obj[paramValue] || '';
            return {
              enabled,
              text: enabled && text ? `（${text}）` : ''
            };
          }
        },
        // 商城右侧悬浮信息展示配置
        {
          keys: ['mallRightFloatingInfoConfig'],
          handler: () => {
            if (!paramValue || typeof paramValue !== 'object') return {enabled: false};
            const wechatShow = paramValue.wechatConfig && Number(paramValue.wechatConfig.show) === 1;
            const phoneShow = paramValue.phoneConfig && Number(paramValue.phoneConfig.show) === 1;
            const enabled = wechatShow || phoneShow;
            if (!enabled) return {enabled: false};
            // 构建带状态后缀的详细文本节点，隐藏项用红色高亮
            const items = [
              {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000225'), show: wechatShow},
              {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000226'), show: phoneShow}
            ];
            const textNodes = [];
            items.forEach((item, index) => {
              if (index > 0) {
                textNodes.push(h('span', '、'));
              }
              const label = `${item.name}-${item.show ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002383') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002384')}`;
              textNodes.push(h('span', {
                style: item.show ? {color: '#19be6b'} : {color: '#ed4014'}
              }, label));
            });
            return {
              enabled,
              customText: h('span', {style: {marginLeft: '5px'}}, [
                h('span', '（'),
                ...textNodes,
                h('span', '）')
              ])
            };
          }
        }
      ];
      const rule = rules.find(r => r.keys.includes(paramKey));
      if (!rule) return h('div');
      const {enabled, text, overflow, customText} = rule.handler();
      nodes.push(renderBadge(enabled));
      if (customText) {
        nodes.push(customText);
      } else if (text) {
        nodes.push(
          overflow
            ? this.checkContentOverflow(h, text, 100, 1, {boxStyles: {width: '355px', color: '#19be6b', margin: '0'}})
            : h('span', {class: 'badgEenableColor'}, text)
        );
      }
      return h('div', {class: 'flex flex-wrap'}, nodes);
    },
    // 配置项权限判断
    checkConfigPermission() {
      const permissionMap = {
        yms: 'ymsConfig_update',
        distributor: 'distributorConfig_update',
        supplier: 'supplierConfig_update'
      };
      const permissionKey = permissionMap[this.systemConfigValue];
      return permissionKey ? this.getPermission(permissionKey) : false;
    }
  },
  components: {
    buttonLayoutConfigurationModal,
    logoConfigModal,
    languageConfigModal,
    suppliePlatformConfigModal,
    autoCancelOrderConfigModal,
    distributorPlatformConfigModal,
    onlineBalanceRechargeConfigModal,
    mallRegisterBusinessTypeConfigModal,
    touristPriceConfigModal,
    platformSelfOperatedProductModel,
    mallRightFloatingInfoConfigModal
  }
};
</script>

<style lang="less" scoped>
.tabs_styles {
  /deep/ .ivu-tabs-bar {
    border-bottom: none;
    background-color: #fff;
    padding: 5px 0 3px 0;
    margin: 0;
  }
}

</style>
